import { mapState, mapGetters, mapActions } from 'vuex'
import router from "../router";
import store from '@/state/store';

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const configComputed = {
  ...mapGetters('config', ['currencies', 'selectedCurrency']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    sidebarSize: (state) => state.sidebarSize,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    mode: (state) => state.mode,
    position: (state) => state.position,
    sidebarView: (state) => state.sidebarView,
    sidebarColor: (state) => state.sidebarColor,
    sidebarImage: (state) => state.sidebarImage,
    visibility: (state) => state.visibility
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword', 'resetPasswordWithToken', 'checkResetToken', 'forgotPassword', 'fetchUserData'])

export const layoutMethods = mapActions('layout', 
['changeLayoutType', 'changeLayoutWidth', 'changeSidebarSize', 'changeTopbar', 'changeMode', 'changePosition', 'changeSidebarView',
 'changeSidebarColor','changeSidebarImage','changePreloader', 'changeVisibility'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const todoComputed = {
  ...mapState('todo', {
    todos: (state) => state.todos
  })
}
export const todoMethods = mapActions('todo', ['fetchTodos'])

export const configMethods = mapActions('config', ['switchCurrency'])

export function hasAccessibleApplicationRoute(applicationCode) {
  return router.getRoutes().find(route => {
    const meta = route.meta || {};

    return (
      !route.path.includes('/:') &&
      meta.application === applicationCode &&
      meta.authRequired &&
      store.getters['auth/hasPermission'](meta.action)
    );
  });
}